import {InfoBubble} from 'js-info-bubble';
import {IMtEvent} from "./imtevent";
import {IRouteOptions} from "./irouteoptions";
import {IMapToolkitOptions} from "./imaptkoptions";
import {IBubbleInfoOptions} from "./ibubbleoptions";
import {MtEventSource} from "./mteventsource";
import {MtMarker} from "./mtmarker";
import {MtMarkerGroupCollection} from "./mkcollection";

var _noop = function () {
};

var _defRouteOptions: IRouteOptions = {
    travelMode: 'TRANSIT',
    strokeColor: 'pink',
    strokeOpacity: 1,
    strokeWeight: 6
};

var _defBubbleInfoOptions: IBubbleInfoOptions = {
    content: '',
    position: null,
    shadowStyle: 1,
    padding: 0,
    backgroundColor: "#fff",
    borderRadius: 2,
    arrowSize: 0,
    borderWidth: 1,
    borderColor: "#f3f3f3",
    disableAutoPan: false,
    hideCloseButton: false,
    arrowPosition: 50,
    backgroundClassName: '',
    minWidth: 300,
    minHeight: 50,
    arrowStyle: 0,
};

export class MapToolkit extends MtEventSource<IMtEvent> {

    private _bubbleMarkup = "<div>{{name}}</div>";

    private _markerSelected: MtMarker;
    private _markerGroupCollection: MtMarkerGroupCollection;
    private _radioSearchPaint: google.maps.Circle;

    private _infoBubbleOpened: any;
    private _routeDrawed: google.maps.DirectionsRenderer;
    private _options: IMapToolkitOptions;

    constructor(public nativeMap: google.maps.Map, _options?: IMapToolkitOptions) {
        super();
        var self = this;
        this._options = _options || {};

        google.maps.event.addListener(self.nativeMap, 'idle', () => {
            self.event(MapToolkit.EVT_MAP_IDLE).emit({source: self, evt: {}});
        });

        google.maps.event.addListener(self.nativeMap, 'click', (event) => {
            self.event(MapToolkit.EVT_MAP_CLICK).emit({source: self, evt: event});
        });

        google.maps.event.addListener(self.nativeMap, "zoom_changed", () => {
            self.event(MapToolkit.EVT_MAP_ZOOM_CHANGED).emit({source: self, evt: {}});
            if (self._markerSelected) {
                self._ubicarInfoBubble(self.nativeMap.getZoom(), self._markerSelected);
            }
        });
        this._markerGroupCollection = new MtMarkerGroupCollection();
    }

    option<T>(name: string, defValue?: any): T {
        return this._options[name] != void 0 ? this._options[name] as T : defValue;
    }

    getSelectedMarker(): MtMarker {
        return this._markerSelected;
    }

    addMarker(marker: MtMarker, group?: string): MapToolkit {
        if (marker) {
            this.addAllMarkers([marker], group);
        }
        return this;
    }

    addAllMarkers(markers: MtMarker[], group?: string): MapToolkit {
        if (markers && markers.length) {
            this._markerGroupCollection.addAllMarkers(markers, group).forEach((mk: MtMarker) => {
                mk.event(MapToolkit.EVT_MAP_MARKER_CLICK).addListener((args) => {
                    this._markerSelected = args.source;
                    this.event(MapToolkit.EVT_MAP_MARKER_CLICK).emit({
                        source: this,
                        marker: args.source,
                        evt: args.evt
                    });
                });
                if (this.option("markerIconSelector")) {
                    mk.setIcon(this.option<Function>("markerIconSelector")(mk.model));
                }
                mk.show(this.nativeMap);
            });
        }
        return this;
    }

    setMarker(marker: MtMarker, group?: string) {
        this.setAllMarkers([marker], group);
    }

    /**
     * Elimina los markers que no estan mostrandose y adiciona los nuevos.
     * @param markers
     * @param group
     */
    setAllMarkers(markers: MtMarker[], group?: string): MapToolkit {
        if (markers && markers.length) {
            var toRemove = [], toUpdate = [], toAdd = [];

            var currMarkers = this._markerGroupCollection.getGroup(group);
            var setMkIds = {}
            //busco los markers que no estan en el mapa y los pongo para adicionar
            //ademas hago un map de los ids para luego verificar los q no estan en currMarkers y eliminarlos
            markers.forEach((m) => {
                setMkIds[m.getId()] = true;
                if (!currMarkers.containsKey(m.getId())) {
                    toAdd.push(m);
                } else {
                    toUpdate.push(m)
                }
            });
            currMarkers.forEach((id, mk) => {
                if (!setMkIds[mk.getId()]) {
                    toRemove.push(mk);
                }
            });
            //actualizo los markers
            toUpdate.forEach((m) => {
                var actualMk = currMarkers.getValue(m.getId());
                actualMk.setPosition(m.getPosition());
                actualMk.setModel(m.model);
            });
            //elimino los que no estan en markers
            this.removeAllMarkers(toRemove, group);
            //adiciono los que no estan en currMarkers
            this.addAllMarkers(toAdd, group);
        }
        return this;
    }

    removeMarker(id: any, group?: string): MtMarker {
        var mk = this._markerGroupCollection.removeMarker(id, group);
        if (mk) {
            mk.remove();
            return mk;
        }
    }

    removeAllMarkers(markers: MtMarker[], group: string) {
        if (markers && markers.length) {
            this._markerGroupCollection.removeMarkers(markers, group).forEach((m) => {
                m.remove();
            });
        }
    }

    removeGroup(group: string) {
        var markers: MtMarker[] = this._markerGroupCollection.removeGroup(group);
        if (markers) {
            markers.forEach((mk) => {
                mk.remove();
            })
        }
    }

    centerMapToMarkers() {
        var markers = this._markerGroupCollection.toArray();
        if (markers.length > 0) {
            var latMin = markers[0].getPosition().lat(),
                latMax = markers[0].getPosition().lat(),
                lngMin = markers[0].getPosition().lng(),
                lngMax = markers[0].getPosition().lng();
            var i;
            for (i = 1; i < markers.length; i++) {
                latMin = markers[i].getPosition().lat() < latMin ? markers[i].getPosition().lat() : latMin;
                latMax = markers[i].getPosition().lat() > latMax ? markers[i].getPosition().lat() : latMax;
                lngMin = markers[i].getPosition().lng() < lngMin ? markers[i].getPosition().lng() : lngMin;
                lngMax = markers[i].getPosition().lng() > lngMax ? markers[i].getPosition().lng() : lngMax;
            }
            var mediaLat = (latMin + latMax) / 2,
                mediaLng = (lngMin + lngMax) / 2;
            //busco el rig mas cercano a la media
            var markerMiddle = markers[0];
            var difCentro = Math.abs(Math.abs(markerMiddle.getPosition().lat()) - Math.abs(mediaLat)) +
                Math.abs(Math.abs(markerMiddle.getPosition().lng() - Math.abs(mediaLng)));
            for (i = 1; i < markers.length; i++) {
                var difRig = Math.abs(Math.abs(markers[i].getPosition().lat()) - Math.abs(mediaLat)) +
                    Math.abs(Math.abs(markers[i].getPosition().lng()) - Math.abs(mediaLng));
                if (difRig < difCentro) {
                    markerMiddle = markers[i];
                    difCentro = difRig;
                }
            }
            this.centerMap(markerMiddle.getPosition(), 5);
        }
    }

    centerMap(pos: google.maps.LatLng, zoom?: number);
    centerMap(pos: string, zoom?: number);
    centerMap(pos: any, zoom?: number) {
        if (typeof (pos) == "string") {
            var vals = pos.split(",");
            pos = new google.maps.LatLng(parseFloat(vals[0]), parseFloat(vals[1]));
        }
        this.nativeMap.setCenter(pos);
        this.nativeMap.setZoom(zoom);
    }

    centerAndZoomToMarkers(positions?: google.maps.LatLng[]) {
        positions = positions || this._markerGroupCollection.toArray().map((mk) => {
                return mk.getPosition();
            });
        var latlngbounds = new google.maps.LatLngBounds();
        for (var i = 0; i < positions.length; i++) {
            latlngbounds.extend(new google.maps.LatLng(positions[i].lat(), positions[i].lng()));
        }
        var zprev = this.nativeMap.getZoom();
        this.nativeMap.fitBounds(latlngbounds);
        this.nativeMap.setZoom(zprev);
    }

    getZoom(): number {
        return this.nativeMap.getZoom();
    }

    getCenter(): google.maps.LatLng {
        return this.nativeMap.getCenter();
    }

    getBounds(): google.maps.LatLngBounds {
        return this.nativeMap.getBounds();
    }

    paintCircle(radio: number, center: google.maps.LatLng,
                circleOpts: google.maps.CircleOptions, clickListener?: Function) {

        var self = this;
        if (self._radioSearchPaint)
            self._radioSearchPaint.setMap(null);

        // Add the circle for this city to the map.
        self._radioSearchPaint = new google.maps.Circle(circleOpts);
        if (clickListener)
            google.maps.event.addListener(self._radioSearchPaint, 'click', function (event) {
                clickListener(event);
            });
        return self._radioSearchPaint;
    }

    showInfoBubble(options: IBubbleInfoOptions) {
        options = Object.assign({}, _defBubbleInfoOptions, options, {
            map: this.nativeMap,
            position: this._getInfoBubblePositionForMarkerPosition(this.nativeMap.getZoom(), options.position)
        });
        this.closeInfoBubble();
        var infoBubble = new InfoBubble(options);
        infoBubble.open();
        this._infoBubbleOpened = infoBubble;
    }

    closeInfoBubble() {
        this._infoBubbleOpened && this._infoBubbleOpened.close();
    }

    showRoute(start: google.maps.LatLng, end: google.maps.LatLng, options?: IRouteOptions): Promise<any> {
        var self = this;
        options = Object.assign({}, _defRouteOptions, options);
        return new Promise((resolve, reject) => {
            var request = {
                origin: start,
                destination: end,
                travelMode: options.travelMode
            };
            var directionsService = new google.maps.DirectionsService();
            var directionsDisplay = new google.maps.DirectionsRenderer({
                polylineOptions: {strokeColor: options.strokeColor},
                suppressMarkers: true
            });
            directionsService.route(request, function (response, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(response);
                    directionsDisplay.setMap(self.nativeMap);
                    self._routeDrawed = directionsDisplay;
                    resolve(self._routeDrawed);
                } else {
                    reject({response, status});
                }
            });
        });
    }

    clearRoute() {
        if (this._routeDrawed) {
            this._routeDrawed.setMap(null);
            this._routeDrawed = null;
        }
    }

    private _getInfoBubblePositionForMarkerPosition(zoom: number, pos: google.maps.LatLng) {
        var newLat = pos.lat() + (0.00004 * Math.pow(2, (19 - zoom)));
        return new google.maps.LatLng(newLat, pos.lng());
    }

    private _ubicarInfoBubble(zoom: number, marker: MtMarker) {
        if (this._infoBubbleOpened) {
            //position infoBubble for each zoom level change, based on arithmetic logic (notice the power of 2)
            this._infoBubbleOpened.setPosition(this._getInfoBubblePositionForMarkerPosition(zoom, marker.getPosition()));
        }
    }

}


// WEBPACK FOOTER //
// ./src/maptoolkit.ts